function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M4.583 19.419l3.803-1.268c.252-.084.529-.064.767.056 1.037.524 2.184.796 3.348.793 2.84-.001 5.436-1.606 6.708-4.15.524-1.038.796-2.185.793-3.347l.001-.448c-.21-3.807-3.25-6.846-7.001-7.055h-.503c-1.162-.003-2.309.269-3.35.795-2.54 1.27-4.146 3.865-4.147 6.708-.003 1.162.268 2.309.792 3.346.12.238.14.514.056.767L4.583 19.42zm17.419-7.92c.003 1.477-.342 2.934-1.006 4.248C19.388 18.965 16.1 21 12.504 21c-1.335.004-2.653-.278-3.868-.824L3.318 21.95c-.782.26-1.526-.483-1.265-1.265l1.773-5.318c-.546-1.215-.828-2.533-.824-3.866.001-3.598 2.035-6.886 5.249-8.493C9.57 2.341 11.027 1.997 12.5 2l.556.002c4.825.266 8.677 4.118 8.945 8.998v.499z",
  transform: "translate(-191 -527) translate(0 100) translate(178 414) translate(13 13)"
}))))));

var SvgIcMessageCircle = function SvgIcMessageCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcMessageCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_message_circle.a3e624d0.svg";
export { ForwardRef as ReactComponent };